module.exports = __webpack_public_path__ + "static/14-edcc2d31c841dea77720a77de87763b1.jpg";